import { ContextBranch } from "@/contexts/Branch"
import { useContext } from "react"


export const useBranch = () => {
    const context = useContext(ContextBranch)
    return context
} 